import { render, staticRenderFns } from "./Forbidden403.vue?vue&type=template&id=6791c62b&"
import script from "./Forbidden403.vue?vue&type=script&lang=js&"
export * from "./Forbidden403.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports